import { render, staticRenderFns } from "./ProductExtraOptionSectionWhereRequestedSelector.vue?vue&type=template&id=2284f1fd&"
import script from "./ProductExtraOptionSectionWhereRequestedSelector.vue?vue&type=script&lang=js&"
export * from "./ProductExtraOptionSectionWhereRequestedSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports